"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _role = require("_a/admin/role/role");
var _message = require("_l/message");
var _vuex = require("vuex");
var _resource = require("@/api/admin/resource/resource");
var _tablePage = _interopRequireDefault(require("_c/CommonForm/table-page"));
var _dept = require("_a/admin/dept/dept");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'role-manage',
  components: {
    TablePage: _tablePage.default
  },
  data: function data() {
    return {
      tableUrl: '/system/role/page',
      columns: [{
        label: '名称',
        prop: 'roleName'
      }, {
        label: '权限字符',
        prop: 'roleKey'
      }, {
        label: '状态',
        slot: 'roleStatus'
      }, {
        label: '数据范围',
        slot: 'dataScope'
      }, {
        label: '操作',
        slot: 'action'
      }],
      queryParams: {},
      dialogShow: false,
      delBtnDisabled: true,
      dialogTitle: '添加角色',
      form: {},
      ids: [],
      rules: {
        roleName: [this.$ruler('角色名称')],
        roleKey: [this.$ruler('角色权限字符串'), {
          pattern: /^[A-Z_]{3,30}$/,
          message: '请输入大写字母或者下划线并且3-30个字符'
        }],
        roleStatus: [this.$ruler('角色状态')]
      },
      roleId: null,
      statusOptionList: [],
      dataScopeOptionList: [],
      dialogModuleShow: false,
      moduleData: [],
      defModuleIds: [],
      deptTree: [],
      dataScopeDeptIds: []
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(["userId"])),
  watch: {
    'form.dataScope': function formDataScope(val) {
      if (val === '2') {
        this.$nextTick(function () {
          var _this = this;
          (0, _dept.getDeptTreeList)().then(function (res) {
            if (res.data) {
              _this.deptTree = res.data;
            }
          });
        });
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getDictListByType'])), {}, {
    /**
     * 刷新
     */
    refresh: function refresh() {
      this.$refs.tablePage.refresh();
    },
    /**
     * 重置搜索条件
     */
    reset: function reset() {
      this.queryParams = {};
      this.$nextTick(function () {
        this.refresh();
      });
    },
    /**
     * 添加弹出框
     */
    addRole: function addRole() {
      this.form = {
        roleStatus: '0'
      };
      this.dialogTitle = '添加角色';
      this.dialogShow = true;
    },
    /**
     * 修改弹出框
     * @param row
     */
    update: function update(row) {
      var _this2 = this;
      this.form = _objectSpread({}, row);
      this.dialogTitle = '修改角色';
      (0, _role.getDataScopeDeptIdsByRoleId)(row.id).then(function (res) {
        if (res.data) {
          _this2.dataScopeDeptIds = res.data;
          _this2.$nextTick(function () {
            this.dialogShow = true;
          });
        }
      });
    },
    /**
     * 点击每一行的checkbox
     */
    selectVal: function selectVal(ids) {
      this.ids = ids.map(function (val) {
        return val['id'];
      });
      this.delBtnDisabled = !this.ids.length;
    },
    /**
     * 批量删除
     */
    removeBatch: function removeBatch() {
      var _this3 = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }).then(function () {
        (0, _role.deleteBatchRoleById)(_this3.ids).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('del');
          } else {
            (0, _message.MessageError)('del');
          }
          _this3.refresh();
        });
      });
    },
    /**
     * 行内删除
     * @param row
     */
    remove: function remove(row) {
      var _this4 = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }).then(function () {
        (0, _role.deleteRoleById)(row.id).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('del');
          } else {
            (0, _message.MessageError)('del');
          }
          // 刷新表格
          _this4.refresh();
        });
      });
    },
    /**
     * 重置表单
     * @param name
     */
    handleReset: function handleReset(name) {
      this.dialogShow = false;
      this.$refs[name].resetFields();
    },
    /**
     * 提交表单
     * @param name
     */
    handleSubmit: function handleSubmit(name) {
      var _this5 = this;
      if (this.form.dataScope === '2') {
        var deptIds = [];
        this.$refs.deptTree.getCheckedNodes(false, true).forEach(function (e) {
          deptIds.push(e.id);
        });
        this.form.deptIds = deptIds;
      }
      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this5.dialogTitle === '添加角色') {
            (0, _role.addRole)(_this5.form).then(function (res) {
              if (res.data) {
                (0, _message.MessageSuccess)('add');
              } else {
                (0, _message.MessageError)('add');
              }
              _this5.cancelDialogAndRefresh();
            });
          } else {
            (0, _role.updateRole)(_this5.form).then(function (res) {
              if (res.data) {
                (0, _message.MessageSuccess)('upd');
              } else {
                (0, _message.MessageError)('upd');
              }
              _this5.cancelDialogAndRefresh();
            });
          }
        }
      });
    },
    /**
     * 关闭弹出框 和 刷新表格
     */
    cancelDialogAndRefresh: function cancelDialogAndRefresh() {
      // 清空表单
      this.handleReset('form');
      // 刷新表格
      this.refresh();
    },
    /**
     * 授权模块
     * @param row
     */
    authModule: function authModule(row) {
      var _this6 = this;
      this.roleId = row.id;
      var that = this;
      (0, _resource.getResourceTreeList)().then(function (res) {
        _this6.moduleData = res.data;
      }).then(function () {
        (0, _resource.getResourceIdListByRoleId)(_this6.roleId).then(function (res) {
          res.data.forEach(function (i, n) {
            var node = that.$refs.moduleTree.getNode(i);
            if (node.isLeaf) {
              that.$refs.moduleTree.setChecked(node, true);
            }
          });
        });
      }).then(function () {
        _this6.$nextTick(function () {
          this.dialogModuleShow = true;
        });
      });
    },
    saveAuthModule: function saveAuthModule() {
      var _this7 = this;
      // 获取选中及半选节点
      var resIds = [];
      this.$refs.moduleTree.getCheckedNodes(false, true).forEach(function (e) {
        resIds.push(e.id);
      });
      var roleResourceDto = {
        userId: this.userId,
        roleId: this.roleId,
        resIds: resIds
      };
      (0, _role.saveAuthResource)(roleResourceDto).then(function (res) {
        if (res.data) {
          (0, _message.MessageSuccess)('upd');
        } else {
          (0, _message.MessageError)('upd');
        }
        _this7.dialogModuleShow = false;
        // 刷新表格
        _this7.refresh();
      });
    }
  }),
  mounted: function mounted() {
    var _this8 = this;
    this.getDictListByType('role_status').then(function (res) {
      _this8.statusOptionList = res;
    });
    this.getDictListByType('data_scope').then(function (res) {
      _this8.dataScopeOptionList = res;
    });
  }
};